import { createRoot } from 'react-dom/client'
import React from 'react'

import Runtime, { init } from '@adobe/exc-app'

import App from './components/App'
import './index.css'

// ⭐ AWS Amplify
import { Amplify } from 'aws-amplify'
import outputs from './config/amplify_outputs.json'

// Configure Amplify with generated outputs
Amplify.configure(outputs)

window.React = require('react')
/* Here you can bootstrap your application and configure the integration with the Adobe Experience Cloud Shell */
try {
  // attempt to load the Experience Cloud Runtime
  require('./exc-runtime')
  // if there are no errors, bootstrap the app in the Experience Cloud Shell
  init(bootstrapInExcShell)
} catch (e) {
  // fallback mode, run the application without the Experience Cloud Runtime
  bootstrapRaw()
}

function bootstrapRaw() {
  /* **here you can mock the exc runtime and ims objects** */
  const mockRuntime = { on: () => {} }
  const mockIms = {}

  // render the actual react application and pass along the runtime object to make it available to the App
  const root = createRoot(document.getElementById('root'))
  root.render(
    <React.StrictMode>
      <App runtime={mockRuntime} ims={mockIms} />
    </React.StrictMode>,
  )
}

function bootstrapInExcShell() {
  // get the Experience Cloud Runtime object
  const runtime = Runtime()

  // use this to set a favicon
  // runtime.favicon = 'url-to-favicon'

  // use this to respond to clicks on the app-bar title
  // runtime.heroClick = () => window.alert('Did I ever tell you you\'re my hero?')

  // ready event brings in authentication/user info
  runtime.on('ready', ({ imsOrg, imsToken, imsProfile, locale }) => {
    // tell the exc-runtime object we are done
    runtime.done()
    const ims = {
      profile: imsProfile,
      org: imsOrg,
      token: imsToken,
    }
    // render the actual react application and pass along the runtime and ims objects to make it available to the App
    const root = createRoot(document.getElementById('root'))
    root.render(
      <React.StrictMode>
        <App runtime={runtime} ims={ims} />
      </React.StrictMode>,
    )
  })

  // set solution info, shortTitle is used when window is too small to display full title
  runtime.solution = {
    icon: 'AdobeExperienceCloud',
    title: 'eggsConnect',
    shortTitle: 'JGR',
  }
  runtime.title = 'eggsConnect'
}

// PWA Service Worker Registration (disabled on localhost for development)
if ('serviceWorker' in navigator && location.protocol === 'https:' && !location.hostname.includes('localhost')) {
  navigator.serviceWorker.register(
    new URL('service-worker.js', import.meta.url),
    { type: 'module' },
  ).then((registration) => {
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated') {
            console.log('SW updated — neue Version aktiv')
          }
        })
      }
    })
  }).catch((err) => {
    console.error('SW registration failed:', err)
  })
} else if ('serviceWorker' in navigator && location.hostname.includes('localhost')) {
  // Unregister any existing SW on localhost
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister())
  })
}
